import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";


/**
 * @Description this page Object  Library's Assign Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Assign({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.OBJECT.";
  return (
    <div>
      <div className="form-element">
        {t(label + "OBJECT-VARIABLE")}
        <TextInput
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          include={['object']}
          isRequired={true}
        />
      </div>
      <div className="form-element">
        {t(label + "VARIABLE")}
        <TextInput
          action={action}
          inputName="item"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          multiline={4}
          fieldType="object"
          displayName={t(label + 'VARIABLE')}
        />
      </div>
    </div>
  );
}
